const initialState = {
  selectedMatchId: null,
  status: "idle", // idle | requested | streaming
  players: [],
  liveSignals: [],
  events: [], // newest-first, bounded
  lastFrameAt: null,
  roundNumber: null,
  serverTick: null,
  mapName: null,
  error: null,
};

const MAX_EVENTS = 500;

export default function anticheatDebugger(state = initialState, action) {
  switch (action.type) {
    case "ACD_SELECT_MATCH":
      return { ...initialState, selectedMatchId: action.matchId, status: "idle" };
    case "ACD_SET_STATUS":
      return { ...state, status: action.status, error: null };
    case "ACD_ERROR":
      return { ...state, error: action.error };
    case "ACD_FRAME":
      return {
        ...state,
        players: action.frame.players || [],
        liveSignals: action.frame.liveSignals || [],
        roundNumber: action.frame.roundNumber,
        serverTick: action.frame.serverTick,
        mapName: action.frame.mapName || state.mapName,
        lastFrameAt: Date.now(),
        status: state.status === "requested" ? "streaming" : state.status,
      };
    case "ACD_EVENT":
      return { ...state, events: [action.event, ...state.events].slice(0, MAX_EVENTS) };
    case "ACD_RESET":
      return initialState;
    default:
      return state;
  }
}
